<template>
    <Head :title="title"/>
    <div class="w-screen h-screen bg-gray-700 flex overflow-hidden">
        <div class="w-1/5 flex">
            <nav class="sidebar-nav">
                <ul>
                    <li class="logo bg-gray-800">
                        <Link :href="route('tour.index')" :title="__('rooomguide.index')">
                            <img class="w-full" src="/assets/img/logo.svg" alt="logo">
                        </Link>
                    </li>
                    <li>
                        <Link :href="route('tour.index')" :title="__('tour.index')">
                            <img src="/assets/icons/icon-menu.svg">
                        </Link>
                    </li>
                </ul>
                <ul class="nav-bottom bg-gradient">
<!--                     <li>
                        <Link :href="route('tour.index')">
                            <img src="/assets/icons/icon-settings.svg">
                        </Link>
                    </li> -->
                    <li>
                        <form @submit.prevent="logout()" class="text-center">
                           <button type="submit">
                                <img src="/assets/icons/icon-logout.svg">
                           </button>
                        </form>
                    </li>
                </ul>
            </nav>
            <div class="w-full border border-gray-800">
                <slot name="left-area"></slot>
            </div>
        </div>

        <div class="h-screen w-4/5">
            <header class="bg-gray-800 flex justify-between px-8 py-2">
                <!-- title area -->
                <div class="flex flex-row w-full justify-between mr-10">
                    <h1 class="text-white mt-3 font-bold">{{ title }}</h1>

                    <div class="pt-2 mr-10">
                        <button v-if="showVisibility" @click.prevent="changeVisibility" class="btn btn-sm btn-black mr-2">
                            <span
                                class="rounded block float-left mr-2 mt-1"
                                style="width: 10px; height: 10px;"
                                v-if="showVisibility == true"
                                :class="visibility ? 'bg-green-600' : 'bg-red-600'"
                            ></span>
                            {{ visibility ? __('tour.visibile') : __('tour.invisible') }}
                        </button>

                        <button v-if="publishTour" @click.prevent="publishTour" class="btn btn-sm btn-petrol mr-2">
                            <Spinner v-if="publish_tour_form.processing" class="float-left mr-1" style="transform: scale(0.5);"/>
                            {{ publish_tour_form.recentlySuccessful ? __('tour.published') :__('tour.publish') }}
                        </button>

                        <button v-if="!form.processing" @click.prevent="update" class="btn btn-sm btn-gradient mr-2 ml-3">
                            {{ form.recentlySuccessful ? __('updated') :__('update') }}
                        </button>
                        <button v-else class="btn btn-sm btn-gradient mr-2 ml-3 opacity-75" disabled>
                            <Spinner class="float-left mr-1" style="transform: scale(0.5);"/>{{ __('updating') }}
                        </button>
                    </div>

                </div>

                <!-- title area -->
                <Link :href="route('my-area')">
                    <i class="user-circle"></i>
                </Link>
            </header>
            <div class="content py-8 overflow-scroll h-full">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3';
import { __ } from '@/locale';
import Spinner from '@/UI/Spinner';


export default {
    props: {
        form: Object,
        publish_tour_form: Object,
        visibility: Number,
        showVisibility: Boolean,
        title: String,
        publishTour: Function,
        changeVisibility: Function,
        update: Function,
    },
    data() {
        return {
            __,
        }
    },

    components: {
        Link,
        Spinner,
        Head,
    },
    methods:{
        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>
